import { APICallV2Post } from '../APICall';

export class RejectFolderApiCall extends APICallV2Post {
    _method = 'folder/invites/reject';
}
